import './productCard.scss';

import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import { TweenLite } from 'gsap/TweenLite';

const setWrapperHeight = (wrapper, el) => {
  wrapper.style.height = `${el.clientHeight}px`;
};
let canSwitchTabs = false;

export function productCard() {
  const cartForm = document.querySelector('[data-role="cart-form"]');

  if (!cartForm) {
    return;
  }

  const stepLabelActiveClass = 'cart-form__step--active';
  const stepLabelInteractionClass = 'cart-form__step--interact';
  const stepSectionActiveClass = 'cart-form__section--active';
  const stepsWrapper = cartForm.querySelector('[data-steps-wrapper]');
  const stepLabels = [...cartForm.querySelectorAll('[data-step-label]')];
  const stepSections = [...cartForm.querySelectorAll('[data-step-section]')];
  const inputs = [...cartForm.querySelectorAll('input, select, textarea')];

  stepSections.forEach((section, i) => {
    const nextButton = section.querySelector('[data-step-button]');

    nextButton.addEventListener('click', (e) => {
      if (!canSwitchTabs) {
        canSwitchTabs = true;
        stepLabels.forEach(label => label.classList.add(stepLabelInteractionClass));
      }

      if (e.currentTarget.dataset.stepSubmit !== undefined) {
        return;
      }

      e.preventDefault();

      setWrapperHeight(stepsWrapper, stepSections[i + 1]);
      section.classList.remove(stepSectionActiveClass);
      stepLabels[i].classList.remove(stepLabelActiveClass);
      stepSections[i + 1].classList.add(stepSectionActiveClass);
      stepLabels[i + 1].classList.add(stepLabelActiveClass);
      TweenLite.to(window, 0.8, { scrollTo: { y: cartForm.offsetTop - 110, autoKill: false } });
    });
  });

  stepLabels.forEach((label, labelIndex) => {
    label.addEventListener('click', (e) => {
      if (canSwitchTabs) {
        stepLabels.forEach((l) => {
          l.classList.toggle(stepLabelActiveClass, e.currentTarget === l);
        });

        stepSections.forEach((s, sectionIndex) => {
          s.classList.toggle(stepSectionActiveClass, sectionIndex === labelIndex);

          if (s.classList.contains(stepSectionActiveClass)) {
            setWrapperHeight(stepsWrapper, s);
          }
        });
      }
    });
  });

  const focusInput = (input) => {
    const tabOfThisInput = input.closest('.cart-form__section');

    stepSections.forEach(
      (section) => {
        section.classList.toggle(stepSectionActiveClass, section === tabOfThisInput);
        setWrapperHeight(stepsWrapper, tabOfThisInput);
      },
    );

    stepLabels.forEach((label, i) => {
      const sectionIndex = stepSections.findIndex(el => el === tabOfThisInput);

      label.classList.toggle(
        stepLabelActiveClass,
        sectionIndex === i,
      );
    });
  };

  const focusFirst = debounce(() => {
    const invalidNode = cartForm.querySelector('input:invalid, select:invalid, textarea:invalid');
    if (invalidNode) {
      focusInput(invalidNode);
    }
  }, 100);

  inputs.forEach((input) => {
    input.addEventListener('invalid', focusFirst);
  });

  const setTabContentHeight = throttle(() => {
    setWrapperHeight(stepsWrapper, stepSections.find(
      section => section.classList.contains(stepSectionActiveClass),
    ));
  }, 300);

  window.addEventListener('resize', setTabContentHeight);

  setTimeout(() => setWrapperHeight(stepsWrapper, stepSections[0]), 0);
}
